(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('customErrorHandler', customErrorHandler);

    function customErrorHandler() {
        return function (translationId) {
            return '';
        };
    }
})();
